export default __webpack_public_path__ + "static/media/shopifyExtension7.d86622ad.svg";